<div class="content">

    <!-- Begin dashboard -->
    <div class="container-fluid " style="max-height: 860px;">

        <!-- Page Heading -->
        <div class="raw">
            <div class=" d-sm-flex align-items-center justify-content-between mb-4">
                <h1 class="dashboard-title">Rules Registration</h1>
            </div>

        </div>


        <!-- Content Row -->
        <div class="row">
            <div class="col-12  d-flex justify-content-between pb-2">
                <div class="col-lg-8 col-md-5 col-sm-12">
                  <div class="google-search-container">

                    <i class="fa fa-search search-icon"></i>

                    <input
                      (keyup)="handleKeyUp($event)"
                      [(ngModel)]="searchText"
                      #searchBox
                      class="google-search-input"
                      type="text"
                      placeholder="Search Rule..."
                    />

                    <i
                      *ngIf="searchBox.value"
                      class="fa fa-times clear-icon"
                      (click)="clearSearch(searchBox)"
                    ></i>

                  </div>
                </div>
                <div class="col-lg-4 col-md-3 col-sm-4 d-flex justify-content-end">
                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                        <button class="btn btn-success" style="background-color: #8bc34a" (click)="_fetchData(2)" > Active</button>
                        <button class="btn btn-danger" (click)="_fetchData(3)"> Inactive</button>
                        <button class="btn btn-secondary active" (click)="_fetchData(1)"> All</button>
                    </div>
                    &nbsp;<button *ngIf="this.authService.hasRole('rule-edit')" class="btn btn-primary btn-add-patient" type="button" routerLink="register" title="Add Rules">
                        <i class="fas fa-plus"></i>
                        <span class="btn-label">Add Rules</span>
                    </button>
                </div>
            </div>


            <div class="col-xl-12 col-md-12 mb-2">
                    <div class="table-panel p-4">
                      <div class="table-responsive table-scroll-x">
                            <table class="table table-sm" matSort (matSortChange)="sortData($event)">
                                <thead>
                                <tr>
                                    <th  scope="col">Sr.No</th>
                                    <th mat-sort-header="ruleName" scope="col">Rules</th>
                                    <th mat-sort-header="description" scope="col">Description</th>
                                    <th mat-sort-header="network" scope="col">Network</th>
                                    <th mat-sort-header="planType" scope="col">Plan Type</th>
                                    <th mat-sort-header="formType" scope="col">Form Type</th>
                                    <th mat-sort-header="category" scope="col">Category</th>
                                    <th mat-sort-header="question" scope="col">Question</th>
                                    <th scope="col">Action</th>
                                </tr>
                                </thead>
                                <tbody *ngFor="let table of tableData| filter: searchText; let i = index">
                                <tr>
                                    <th scope="row">{{i + 1}}</th>
                                    <td [routerLink]="this.authService.hasRole('rule-edit') ? ['details/', table.id]:null">{{table.ruleName ? table.ruleName : '-'}}</td>
                                    <td>{{table.description ? table.description : '-'}}</td>
                                    <td>{{table.network ? table.network : '-'}}</td>
                                    <td>{{table.planType ? table.planType : '-'}}</td>
                                    <td>{{table.formType ? table.formType : '-'}}</td>
                                    <td>{{table.category ? table.category : '-'}}</td>
                                    <td>{{table.question ? table.question : '-'}}</td>
                                    <!--<td *ngIf="table.active"><i class="fa-solid fa-square-check"
                                                                style="color: #34ce57"></i></td>
                                    <td *ngIf="!table.active"><i class="fa-solid fa-square-check "
                                                                 style="color: #dc3545"></i></td>-->
                                    <td>
                                        <a title="Edit" [routerLink]="this.authService.hasRole('rule-edit') ? ['details/', table.id]:null"><i
                                                class="fa-solid fa-user-pen"></i></a>&nbsp;
                                         <a title="Delete" (click)="deleteEntry(table.id)" ><i class="fa-regular fa-trash-can text-danger"></i></a>
                                    </td>
                                </tr>
                                </tbody>
                                <tbody *ngIf="tableData == null || tableData.length == 0">
                                <tr>
                                    <td colspan="6" class="text-center"> No record found !</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</div>
